import styled from "styled-components";
import { borderRadius } from "../../../design-system/tokens/borders";
import { rawColors } from "../../../design-system/tokens/colors";

export const Root = styled.div<{
  $variant: "card" | "plain";
  $minHeight?: string;
  $shrinkToContent: boolean;
}>`
  display: flex;
  flex-direction: column;
  flex: ${({ $shrinkToContent }) => ($shrinkToContent ? "0 1 auto" : "1 1 auto")};
  min-height: ${({ $minHeight }) => $minHeight ?? "0"};
  min-width: 0;
  overflow: hidden;

  ${({ $variant }) =>
    $variant === "card"
      ? `
    border: 1px solid ${rawColors.stroke[200]};
    border-radius: ${borderRadius.lg};
    background: ${rawColors.structural.white};
  `
      : ""}
`;

const CONTENT_HEIGHT_CAP_DEFAULT = "min(400px, 55vh)";

export const ScrollRegion = styled.div<{
  $hideScrollbar: boolean;
  $maxScrollHeight?: string;
  $insetTableChrome: boolean;
  $shrinkToContent: boolean;
  $horizontalOverflow: "auto" | "hidden";
}>`
  position: relative;
  ${({ $shrinkToContent, $maxScrollHeight }) => {
    const fillMax = $maxScrollHeight ?? "none";
    const contentMax = $maxScrollHeight ?? CONTENT_HEIGHT_CAP_DEFAULT;
    return $shrinkToContent
      ? `
    flex: 0 1 auto;
    height: auto;
    min-height: 0;
    max-height: ${contentMax};
  `
      : `
    flex: 1 1 auto;
    height: 0;
    min-height: 0;
    max-height: ${fillMax};
  `;
  }}
  overflow-y: auto;
  overflow-x: ${({ $horizontalOverflow }) => $horizontalOverflow};
  isolation: isolate;
  display: flex;
  flex-direction: column;

  ${({ $insetTableChrome }) =>
    $insetTableChrome
      ? `
    border-left: 1px solid ${rawColors.stroke[200]};
    border-top: 1px solid ${rawColors.stroke[200]};
    box-shadow: inset -1px 0 0 ${rawColors.stroke[200]};
  `
      : ""}

  ${({ $hideScrollbar }) =>
    $hideScrollbar
      ? `
    scrollbar-width: none;
    -ms-overflow-style: none;
    &::-webkit-scrollbar {
      display: none;
    }
  `
      : ""}

  ${({ $shrinkToContent }) =>
    !$shrinkToContent
      ? `
    & > * {
      min-height: 0;
    }
  `
      : ""}

  table {
    table-layout: auto;
    width: 100%;
  }

  tbody td {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const FooterSlot = styled.div`
  flex: 0 0 auto;
  background: ${rawColors.structural.white};
  border-top: 1px solid ${rawColors.stroke[200]};
`;
